import React from 'react';

export default function BlockerTitle({title}) {
  if(!title) {
    return null;
  }

  return <div className="title">{title}</div>;
};
